module.exports = __webpack_public_path__ + "img/artboard10.d8a3dbc7.png";